const initialstate = {
  newFundingType: false,
  id: '',
  funding: null,
};

export default initialstate;
